export class PeriodicitaSvazku {
  den: string = '';
  active: boolean = false;
  vydani: string = "0";
  pocet_stran: number = 0;
  nazev: string = '';
  podnazev: string = '';
}
